import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { mapDetailsDto } from '../../../mapping/reservation'
import { HttpError } from '../../../types/common'
import { showErrorToast } from '../../../utils/errors'
import { queryNames } from '../../queries'

const dataApi = DataApi.getInstance()

export default function useGetReservationDetails(uuid: string, onError: (error: AxiosError<HttpError>) => void) {
  const texts = useTranslation().t

  const query = useQuery([queryNames.getReservationDetails, uuid], async () => {
    const { data } = await dataApi.getReservationDetails(uuid)
    return mapDetailsDto(data)
  }, {
    staleTime: Infinity,
    refetchOnMount: 'always',
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
      onError(error)
    }
  })

  return query
}
